import React from 'react';
import { useQuery } from 'react-query';
import useSize from '../../../hooks/useSize';
import { getStatisticsPlants } from '../../../services/statiscsDateService';
import { Statistics } from '../../../@types/statistics';
import { Loading } from '../../components/Loadings/loading';
import { StatisticsWidget5 } from '../../../../_metronic/partials/widgets';
import { PaymentVolumeChart } from '../../dashboard/StatisticsMenu/StatisticsMenuCompany/PaymentVolumeChart';

export const SubscriptionStatsTab: React.FC = () => {
  const { width: largura } = useSize();
  const { data: statistics, isLoading: loading } = useQuery<Statistics>(
    "getStatistics",
    async () => {
      const myStatistics = await getStatisticsPlants();
      return myStatistics;
    },
  );

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <Loading myClass={`spinner-border text-primary`} />
      </div>
    );
  }

  return (
    <>
      {largura < 1200 ? (
        <div className='card shadow-sm border border-dashed border-gray-300'>
          <div className='card-header border-0 cursor-pointer' role='button' data-bs-toggle='collapse' data-bs-target='#kt_subscription_stats_mob'>
            <h3 className='card-title fw-bolder m-0'>Estatísticas de Assinatura</h3>
            <div className='card-toolbar'>
              <i className='bi bi-chevron-down fs-3'></i>
            </div>
          </div>
          <div id='kt_subscription_stats_mob' className='collapse show'>
            <div className='card-body p-5 pt-0'>
              <div className='d-flex flex-column gap-5'>
                <StatisticsWidget5
                  className='card-xl-stretch'
                  svgIcon='/media/icons/duotune/finance/fin002.svg'
                  color='primary'
                  iconColor='white'
                  title={`${statistics && statistics.mrr ? statistics.mrr.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() : '0,00'}`}
                  description='MRR - Faturamento Mensal (R$)'
                  descriptionColor='white'
                  titleColor='white'
                  largura={largura}
                  style={{ width: '100%', marginBottom: 0 }}
                />
                <StatisticsWidget5
                  className='card-xl-stretch'
                  svgIcon='/media/icons/duotune/general/gen044.svg'
                  color='danger'
                  iconColor='white'
                  title={`${statistics && statistics.defaultRate ? statistics.defaultRate.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 }) : '0,0'}%`}
                  description='Taxa de Inadimplência'
                  descriptionColor='white'
                  titleColor='white'
                  largura={largura}
                  style={{ width: '100%', marginBottom: 0 }}
                />
                <StatisticsWidget5
                  className='card-xl-stretch'
                  svgIcon='/media/icons/duotune/arrows/arr061.svg'
                  color='warning'
                  iconColor='white'
                  title={`${statistics && statistics.churnRate ? statistics.churnRate.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 }) : '0,0'}%`}
                  description='Churn Rate (Cancelamentos)'
                  descriptionColor='white'
                  titleColor='white'
                  largura={largura}
                  style={{ width: '100%', marginBottom: 0 }}
                />
                <div className='mt-5'>
                  <PaymentVolumeChart />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='card shadow-sm mb-8 border border-dashed border-gray-300'>
          <div className='card-header border-0 cursor-pointer' role='button' data-bs-toggle='collapse' data-bs-target='#kt_subscription_stats_desk'>
            <h3 className='card-title fw-bolder m-0'>Estatísticas de Assinatura</h3>
            <div className='card-toolbar'>
              <i className='bi bi-chevron-down fs-3'></i>
            </div>
          </div>
          <div id='kt_subscription_stats_desk' className='collapse show'>
            <div className='card-body p-5 pt-0'>
              <div className='row g-5'>
                <div className='col-lg-3 d-flex flex-column gap-5'>
                  <StatisticsWidget5
                    className='card-xl-stretch'
                    svgIcon='/media/icons/duotune/finance/fin002.svg'
                    color='primary'
                    iconColor='white'
                    title={`${statistics && statistics.mrr ? statistics.mrr.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() : '0,00'}`}
                    description='MRR - Faturamento Mensal (R$)'
                    descriptionColor='white'
                    titleColor='white'
                    largura={largura}
                    style={{ width: '100%', marginBottom: 0 }}
                  />
                  <StatisticsWidget5
                    className='card-xl-stretch'
                    svgIcon='/media/icons/duotune/general/gen044.svg'
                    color='danger'
                    iconColor='white'
                    title={`${statistics && statistics.defaultRate ? statistics.defaultRate.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 }) : '0,0'}%`}
                    description='Taxa de Inadimplência'
                    descriptionColor='white'
                    titleColor='white'
                    largura={largura}
                    style={{ width: '100%', marginBottom: 0 }}
                  />
                  <StatisticsWidget5
                    className='card-xl-stretch'
                    svgIcon='/media/icons/duotune/arrows/arr061.svg'
                    color='warning'
                    iconColor='white'
                    title={`${statistics && statistics.churnRate ? statistics.churnRate.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 }) : '0,0'}%`}
                    description='Churn Rate (Cancelamentos)'
                    descriptionColor='white'
                    titleColor='white'
                    largura={largura}
                    style={{ width: '100%', marginBottom: 0 }}
                  />
                </div>
                <div className='col-lg-9'>
                  <PaymentVolumeChart />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
